const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the user notifications component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('userNotifications', ['Application', 'Authorization', 'Notifications', function (Application, Authorization, Notifications) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      hmenu: '=',
    },
    template: require('../../templates/directives/user-notifications.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.user;
      self.appNotifications = Application.notifications;
      self.notifications = [];
      self.open = false;
      self.shim = false;
      self.count = 0;

      self.toggle = function($event) {
        $scope.hmenu.inbox = !$scope.hmenu.inbox;
        self.toggleShim($event);
      };

      self.toggleShim = function($event) {
        
        $event.stopPropagation();
        self.shim = !self.shim;

        if ($event.currentTarget.classList.contains('shim')) {
          $scope.hmenu.inbox = !$scope.hmenu.inbox;
        }
      };

      self.refresh = function() {
        if (!Authorization.hasValidAuthToken()) {
          return;
        }
        if (!Authorization.getAuthToken() || !Authorization.getAuthToken().user) {
          return;
        }
        if (!self.user) {
          self.user = Authorization.getAuthToken().user;
        }

        Notifications.find({
          user: self.user._id,
          archived: false,
          no_app: '$ne,true',
          fields: 'user,company,message,user_from,archived,viewed,createdAt,no_app',
          'user_from-populate': 'first_name,last_name,full_name,email,image',
          sort: 'createdAt,-1',
          page: 1,
          per_page: 200
        }, function(data) {
          self.count = 0;
          self.notifications = [];
          for (var i = 0; i < data.length; i++) {
            if (data[i].message) {
              self.notifications.push(data[i]);
              if (!data[i].viewed) {
                self.count++;
              }
            }
          }
        //  send count
          $scope.hmenu.messageCount = self.count;
        }, function(err) {
          console.log('Error in retrieving user notifications.');
        });
      };

      self.markComplete = function(notification) {
        Notifications.update({subresource: notification._id}, {
          archived: true
        }, function (data) {
          self.markViewed(notification);
          self.refresh();
        }, function (err) {
          console.log('Error in archiving user notification.');
        });
      };

      self.markViewed = function(notification) {
        if (notification.viewed) {
          return;
        }
        Notifications.update({subresource: notification._id}, {
          viewed: true,
          viewed_at: new Date()
        }, function(success) {
          self.refresh();
        }, function(error) {
          console.log('Error marking notification as viewed.')
        });
      };

      self.viewItem = function (notification) {
        if (self.isAssignment(notification)) {
          self.goToItem(notification.assignment);
          return;
        }
        if (notification.type === 'share') {
          self.goToItem(notification.share || notification.item);
          return;
        }
      };

      // *** Start functions that will be depracated when notifications are fully transitioned ***
      self.goToItem = function (item) {
        if (item.article) {
          Application.navigation.goTo('/view/articles/' + item.article._id);
          return;
        }
        if (item.event) {
          Application.navigation.goTo('/view/events/' + item.event._id);
          return;
        }
        if (item.media) {
          var type = item.media.type === 'video' ? 'videos' : item.media.type === 'file' ? 'files' : null;
          if (!type) {
            console.log('no valid type');
            return;
          }
          Application.navigation.goTo('/view/' + type + '/' + item.media._id);
          return;
        }
        if (item.track) {
          var track = typeof item.track === 'string' ? item.track : item.track._id;
          Application.navigation.goTo('/view/tracks/' + track);
          return;
        }
      };

      self.isAssignment = function (notification) {
        if (notification.type !== 'assignment') {
          return false;
        }
        if (!notification.assignment) {
          return false;
        }
        if (!notification.assignment.assignee) {
          console.log('notifications warning', notification);
          return false;
        }
        return notification.assignment.assignee._id.toString() === self.user._id.toString();
      };
      // *** End functions that will be depracated when notifications are fully transitioned ***

      $scope.$watch('notifs.appNotifications.getUserNotifications()', function (newVal, oldVal) {
        if (newVal !== oldVal) {
          self.refresh();
        }
      });

      self.refresh();

    }],
    controllerAs: 'notifs'
  };
}]);
